export default {
  'pages.rental.table.title': '出租资金流水历史记录',
  'pages.rental.table.columns.propRentalId': '出租记录ID',
  'pages.rental.table.columns.parkingStructureName': '房源名称',
  'pages.rental.table.columns.recordType': '流水类型',
  'pages.rental.table.columns.amount': '金额',
  'pages.rental.table.columns.paymentDate': '付款日期',
  'pages.rental.table.columns.paidUntilMonth': '账期',
  'pages.rental.table.columns.remarks': '备注',
  'pages.rental.table.columns.operations': '操作',

  'pages.rental.recordType.income': '收入',
  'pages.rental.recordType.expense': '支出',

  'pages.rental.actions.add': '资产收支登记',
  'pages.rental.modal.createTitle': '新增资产收支登记',
  'pages.rental.modal.editTitle': '编辑资产收支登记',
  'pages.rental.tabs.property': '房产',
  'pages.rental.tabs.parking': '车位',
  'pages.rental.asset.property': '出租房',
  'pages.rental.asset.parking': '出租车位',
  'pages.rental.parking.pageTitle': '出租车位管理',
  'pages.rental.parking.form.title.create': '新增出租车位',
  'pages.rental.parking.form.title.edit': '编辑出租车位',
  'pages.rental.actions.view': '查看',
  'pages.rental.actions.edit': '编辑',
  'pages.rental.actions.delete': '删除',
  'pages.rental.actions.batchDelete': '批量删除',

  'pages.rental.form.createTitle': '新建流水记录',
  'pages.rental.form.editTitle': '编辑流水记录',
  'pages.rental.form.propRentalId': '出租资产',
  'pages.rental.form.propRentalIdRequired': '请选择出租资产',
  'pages.rental.form.propRentalIdPlaceholder': '请选择出租资产',
  'pages.rental.form.recordType': '流水类型',
  'pages.rental.form.recordTypeRequired': '请选择流水类型',
  'pages.rental.form.recordTypePlaceholder': '请选择流水类型',
  'pages.rental.form.amount': '金额',
  'pages.rental.form.amountRequired': '请输入金额',
  'pages.rental.form.amountPlaceholder': '请输入金额',
  'pages.rental.form.paymentDate': '付款日期',
  'pages.rental.form.paymentDateRequired': '请选择付款日期',
  'pages.rental.form.paymentDatePlaceholder': '请选择付款日期',
  'pages.rental.form.paidUntilMonth': '账期',
  'pages.rental.form.paidUntilMonthPlaceholder': '例如：2025-06',
  'pages.rental.form.remarks': '备注',

  'pages.rental.form.section.basic': '基本信息',
  'pages.rental.form.section.record': '流水信息',
  'pages.rental.form.section.remarks': '备注信息',
  'pages.rental.form.section.attachments': '附件信息',
  'pages.rental.form.attachmentsDefaultName': '附件',
  'pages.rental.form.attachmentsUpload': '点击上传文件',
  'pages.rental.form.attachmentsHelp': '支持多文件上传，可同时选择多个文件（图片、PDF、Word、Excel、TXT），单个文件不超过 50MB',
  'pages.rental.form.attachmentsTypeError': '仅支持上传图片、PDF、Word、Excel 或 TXT 文件',
  'pages.rental.form.attachmentsSizeError': '文件大小不能超过 50MB',
  'pages.rental.form.attachmentsUploadSuccess': '{fileName} 上传成功',
  'pages.rental.form.attachmentsUploadFailed': '{fileName} 上传失败',
  'pages.rental.form.attachmentsView': '查看文件',

  'pages.rental.detail.title': '流水记录详情',
  'pages.rental.detail.propRentalId': '出租记录ID',
  'pages.rental.detail.recordType': '流水类型',
  'pages.rental.detail.amount': '金额',
  'pages.rental.detail.paymentDate': '付款日期',
  'pages.rental.detail.paidUntilMonth': '账期',
  'pages.rental.detail.remarks': '备注',
  'pages.rental.detail.createdTime': '创建时间',

  'pages.rental.confirm.deleteTitle': '确认删除',
  'pages.rental.confirm.deleteContent': '确定要删除这条流水记录吗？',
  'pages.rental.confirm.batchDeleteTitle': '确认批量删除',
  'pages.rental.confirm.batchDeleteContent':
    '确定要删除选中的 {count} 条记录吗？',

  'pages.rental.message.createSuccess': '创建成功',
  'pages.rental.message.createFailed': '创建失败',
  'pages.rental.message.updateSuccess': '更新成功',
  'pages.rental.message.updateFailed': '更新失败',
  'pages.rental.message.deleteSuccess': '删除成功',
  'pages.rental.message.deleteFailed': '删除失败',
  'pages.rental.message.batchDeleteSuccess': '批量删除成功',
  'pages.rental.message.batchDeleteFailed': '批量删除失败',
  'pages.rental.message.loadFailed': '加载记录失败',
  'pages.rental.message.selectRecords': '请先选择要删除的记录',
};
